<button
  *ngIf="isLogin && bookmarked.refUid != uid"
  nbButton
  ghost
  shape="round"
  status="primary"
  size="small"
  class="action-button"
  [disabled]="loading"
  [class.btn-pulse]="loading"
  (click)="bookmark()"
>
  <nb-icon
    [icon]="bookmarked.value ? 'bookmark' : 'bookmark-outline'"
    status="success"
  ></nb-icon>
</button>
